import { render, staticRenderFns } from "./twoLayerButton.vue?vue&type=template&id=50b9e5a1&scoped=true&"
import script from "./twoLayerButton.vue?vue&type=script&lang=js&"
export * from "./twoLayerButton.vue?vue&type=script&lang=js&"
import style0 from "./twoLayerButton.vue?vue&type=style&index=0&id=50b9e5a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b9e5a1",
  null
  
)

export default component.exports